import { Injectable, inject } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RecaptchaService {
  recaptchaV3Service = inject(ReCaptchaV3Service);


  async captchaGetToken(action: string) {
    return await firstValueFrom(this.recaptchaV3Service.execute(action));
  }
}
